import { render, staticRenderFns } from "./ProjectProcessGantt.vue?vue&type=template&id=58b956bc&scoped=true&lang=pug&"
import script from "./ProjectProcessGantt.vue?vue&type=script&lang=ts&"
export * from "./ProjectProcessGantt.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectProcessGantt.vue?vue&type=style&index=0&id=58b956bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b956bc",
  null
  
)

export default component.exports